<template>
    <section :class="[namespace(), skinStyle]">
        <div :class="mdsNS('button-group')">
            <button
                v-for="item in dataModel"
                type="button"
                :class="btnClasses(item)"
                :value="item.id"
                :key="item.id"
                @click="click(item)"
            >
                {{ item.name }}
            </button>
        </div>
    </section>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-button-group',
    mixins: [mixins],
    props: {
        dataModel: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    created() {
        this.namespace = utils.namespace('ui-button-group', false);
    },
    methods: {
        click(item) {
            if (!item.selected) {
                this.$emit('change', item);
            }
        },
        btnClasses(item) {
            const cls = ['button', 'button--secondary', 'button--small'];
            if (item.selected) {
                cls.push('button--active');
            }
            return this.mdsNS(cls);
        }
    }
};
</script>
